import React from "react";
import { useNavigate } from "react-router-dom";

export default function LegalLayout({ title, children }) {
  const navigate = useNavigate();
  return (
    <div className="dw-legal">
      <div className="dw-legal__header">
        <button className="dw-legal__back" onClick={() => navigate(-1)}>← 戻る</button>
        <h1 className="dw-legal__title">{title}</h1>
      </div>
      <div className="dw-legal__content">
        {children}
      </div>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@400;500;700&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
:root{--gold:#d4af6e;--gold-dk:#c49a50;--dark:#1a1416;--dark-m:#2a2024;--ivory:#f5efe6;--fb:'Zen Kaku Gothic New',-apple-system,sans-serif}
.dw-legal{max-width:640px;margin:0 auto;min-height:100vh;background:linear-gradient(170deg,var(--dark) 0%,var(--dark-m) 100%);font-family:var(--fb);color:rgba(245,239,230,.75)}
.dw-legal__header{padding:16px 18px;display:flex;align-items:center;gap:14px;border-bottom:1px solid rgba(212,175,110,.08);background:rgba(26,20,22,.8);backdrop-filter:blur(20px);position:sticky;top:0;z-index:10}
.dw-legal__back{padding:8px 14px;border-radius:8px;border:1px solid rgba(212,175,110,.12);background:transparent;color:rgba(212,175,110,.6);font-size:12px;cursor:pointer;font-family:var(--fb);white-space:nowrap}
.dw-legal__title{font-size:17px;font-weight:700;color:var(--ivory)}
.dw-legal__content{padding:24px 20px 40px;line-height:1.85;font-size:13.5px}
.dw-legal__date{font-size:12px;color:rgba(212,175,110,.4);margin-bottom:20px}
.dw-legal__content h2{font-size:15px;font-weight:700;color:var(--ivory);margin-top:28px;margin-bottom:10px;padding-bottom:6px;border-bottom:1px solid rgba(212,175,110,.06)}
.dw-legal__content p{margin-bottom:10px}
.dw-legal__content strong{color:var(--ivory)}
.dw-legal__company{margin-top:32px;text-align:right;color:rgba(212,175,110,.5);font-weight:600}
`}</style>
    </div>
  );
}
